import { render, staticRenderFns } from "./TopFilter.vue?vue&type=template&id=8d677234&scoped=true"
import script from "./topFilter.ts?vue&type=script&lang=ts&external"
export * from "./topFilter.ts?vue&type=script&lang=ts&external"
import style0 from "./TopFilter.vue?vue&type=style&index=0&id=8d677234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d677234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d677234')) {
      api.createRecord('8d677234', component.options)
    } else {
      api.reload('8d677234', component.options)
    }
    module.hot.accept("./TopFilter.vue?vue&type=template&id=8d677234&scoped=true", function () {
      api.rerender('8d677234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/TopFilter.vue"
export default component.exports